import { useQuery } from "@tanstack/react-query";
import { PhoneNumberAdminService } from "@/services/admin/PhoneNumberAdminService";
import type { PhoneNumberFilters } from "@/types/phone-numbers";

export const usePhoneNumbers = (filters?: PhoneNumberFilters, page: number = 1, pageSize: number = 50) => {
  return useQuery({
    queryKey: ["admin-phone-numbers", filters, page, pageSize],
    queryFn: () => PhoneNumberAdminService.getAllPhoneNumbers(filters, pageSize, (page - 1) * pageSize),
  });
};

export const usePhoneNumberStats = (filters?: PhoneNumberFilters) => {
  return useQuery({
    queryKey: ["admin-phone-number-stats", filters],
    queryFn: () => PhoneNumberAdminService.getPhoneNumberStats(filters),
  });
};

export const usePhoneNumberSearch = (phoneNumber: string) => {
  return useQuery({
    queryKey: ["admin-phone-number-search", phoneNumber],
    queryFn: () => PhoneNumberAdminService.searchByPhoneNumber(phoneNumber),
    enabled: phoneNumber.replace(/\D/g, "").length >= 3,
  });
};

export const usePhoneNumberCountryCodes = () => {
  return useQuery({
    queryKey: ["admin-phone-number-country-codes"],
    queryFn: () => PhoneNumberAdminService.getCountryCodes(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
